module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26002/sass/messagesWidgetShell.sass"